var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import * as React from 'react';
const SvgTodasAsCategorias = _a => {
  var {
      size
    } = _a,
    props = __rest(_a, ["size"]);
  return React.createElement("svg", Object.assign({
    width: size || 24,
    height: size || 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: props.role,
    "aria-hidden": props['aria-hidden'] || true
  }, props), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.7144 9.50692L11.012 10.8653C10.4182 10.9691 9.85211 10.5726 9.74728 9.97809L8.389 2.27693C8.22031 1.31871 9.29416 0.634525 10.0922 1.19192L19.1515 7.53541C19.9491 8.09387 19.673 9.33815 18.7144 9.50692ZM5.625 21.8794C8.59364 21.8794 11 19.4731 11 16.5044C11 13.5358 8.59364 11.1294 5.625 11.1294C2.65636 11.1294 0.25 13.5358 0.25 16.5044C0.25 19.4731 2.65636 21.8794 5.625 21.8794ZM5.625 12.1294C8.04136 12.1294 10 14.0881 10 16.5044C10 18.9208 8.04136 20.8794 5.625 20.8794C3.20864 20.8794 1.25 18.9208 1.25 16.5044C1.25 14.0881 3.20864 12.1294 5.625 12.1294ZM13.4379 21.5336C12.7581 21.4137 12.3041 20.7644 12.4242 20.0852L13.7277 12.6924C13.8477 12.0124 14.4963 11.5586 15.1762 11.6786L22.5682 12.9821C23.2484 13.1021 23.7032 13.7513 23.582 14.4298L22.2791 21.8235C22.1579 22.503 21.5103 22.9571 20.8307 22.8371L13.4379 21.5336ZM21.2944 21.649C21.2701 21.7852 21.1402 21.8763 21.0044 21.8523L13.6116 20.5488C13.4761 20.5249 13.385 20.3946 13.4089 20.259L14.7125 12.8661C14.7365 12.7302 14.8663 12.6394 15.0024 12.6634L22.3945 13.9669C22.5306 13.9909 22.6214 14.1205 22.5974 14.2551L21.2944 21.649ZM18.5779 8.35402C18.6456 8.40142 18.6221 8.50724 18.5408 8.52154L10.8391 9.8798C10.7892 9.88852 10.7411 9.85483 10.7321 9.80387L9.37383 2.10285C9.35955 2.02176 9.45116 1.96339 9.51912 2.01086L18.5779 8.35402Z",
    fill: props.color || 'currentColor'
  }));
};
export default SvgTodasAsCategorias;